import type { Price, PriceHistory } from 'src/types';

import type { GAOfferStatus, GAPrice, GAPriceType } from './types';

export function getTypeFromStatus(
  status: GAOfferStatus | undefined
): GAPriceType {
  switch (status) {
    case 'international':
    case 'variant':
    case '':
      return 'normal';
    case undefined:
    case 'raw':
    default:
      return '';
  }
}

export function getGAPriceFromObject(
  price: Price | PriceHistory,
  status: GAOfferStatus | undefined
) {
  switch (price.__typename) {
    case 'Price':
      return price;
    case 'PriceHistory':
    default:
      return {
        ...price,
        type: getTypeFromStatus(status),
      };
  }
}

export function getGAPrice(
  price: Price | PriceHistory | number | undefined | null,
  status: GAOfferStatus | undefined
): GAPrice | Price | undefined | null {
  return typeof price === 'object' && price !== null
    ? getGAPriceFromObject(price, status)
    : {
        price,
        type: getTypeFromStatus(status),
      };
}

export function getGAFeatured(featured: boolean) {
  return featured ? 'Featured' : 'Not Featured';
}
